import React from 'react';
import ProfilePicture from 'components/profile/profile-picture'
import { CSSTransitionGroup } from 'react-transition-group'

import { 
	formatDeadlineDate,
	getPrimaryColumnValue
} from 'utils'

const GanttTaskInfo = props => {
    const {
        isVisible,
        task,
        direction,
        currentProject
    } = props

    let dateString = null

    if(task.start && task.end && task.start !== task.end){
        dateString = formatDeadlineDate(task.start)+' - '+formatDeadlineDate(task.end)
    }else if(task.end){
        dateString = formatDeadlineDate(task.end)
    }else if(task.start){
        dateString = formatDeadlineDate(task.start)
    }

    const className = "gantt-task-info "+(direction ? direction : '')

    const taskUsers = getPrimaryColumnValue('people', task, currentProject)

    return (
        <CSSTransitionGroup 
            transitionName="pop" 
            transitionEnterTimeout={1} 
            transitionLeaveTimeout={200}
            className="gantt-task-info-container"
        >
            { isVisible ?
                <div className={className}>
                    <p>
                        { task.name }
                    </p>
                    <span className="disclaimer">
                        { dateString }
                    </span>
                    { taskUsers.length ? 
                        <ul className="user-list">
                            { taskUsers.map((userId, index) => {
                                return (
                                    <ProfilePicture 
                                        key={index} 
                                        userId={userId}
                                        isTiny={true} 
                                    />
                                )
                            })}
                        </ul>
                    : null }
                </div>
            : null }
        </CSSTransitionGroup>
    )
};

export default GanttTaskInfo;


// WEBPACK FOOTER //
// ./src/sections/projects/project/project-tasks/gantt/gantt-task-info.jsx